import React from "react";
import Home from '../pages/Home';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./Login";

const SigninWidget = () => {

  return (
    <div>
      <AuthenticatedTemplate>
        <Home />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  )
}

export default SigninWidget
